<template>
  <div class="banner-editor-split-view">
    <div
      class="editor-preview-container"
      v-if="item">
      <div class="preview-header-container">
        <h5 class="name"><i class="fas fa-edit"></i> แก้ไขป๊อปอัพ</h5>
        <BackgroundImageChooser
          :image.sync="item.coverImage">
          <span slot="button-text">เปลี่ยนภาพป๊อปอัพ</span>
        </BackgroundImageChooser>
      </div>
      <ElementImageContainer
        v-if="item.coverImage"
        class="popup-item"
        :data="item"
        :thumborSize="'cover1200w675h'"/>
      <ElementImageContainer
        v-if="!item.coverImage"
        class="popup-item"
        :data="item"/>
      <small class="suggested-size">ขนาดที่เหมาะสม 1200x675</small>
      <div class="preview-header-container header-mobile">
        <h5 class="name"><i class="fas fa-mobile-alt"></i> แก้ไขป๊อปอัพสำหรับแสดงผลบนมือถือ</h5>
        <BackgroundImageChooser
          :image.sync="item.mobileCoverImage">
          <span slot="button-text">เปลี่ยนภาพป๊อปอัพ</span>
        </BackgroundImageChooser>
      </div>
      <ElementImageContainer
        v-if="item.mobileCoverImage"
        class="popup-item"
        fieldName="mobileCoverImage"
        :data="item"
        :thumborSize="'cover350w625h'"
        isMobile />
      <ElementImageContainer
        v-if="!item.mobileCoverImage"
        class="popup-item"
        fieldName="mobileCoverImage"
        :thumborSize="'cover350w625h'"
        :data="item"
        isMobile />
      <small class="suggested-size">ขนาดที่เหมาะสม 350x625</small>
    </div>
    <div
      class="editor-metadata-container"
      v-if="item">
      <div class="row">
        <div class="col-md-12">
          <FormGroup>
            <h5 class="name">ลิงก์</h5>
            <input
              type="text"
              class="form-control"
              :disabled="item.syncWithParent"
              v-model="item.link.url"/>
            <div class="form-check form-check-inline">
              <input
                id="checkBoxNewTab"
                class="form-check-input"
                type="checkbox"
                value="_blank"
                v-model="item.link.target">
              <label
                class="form-check-label"
                for="checkBoxNewTab">
                &nbsp; เปิดลิงก์ในแท็บใหม่
              </label>
            </div>
          </FormGroup>
          <FormGroup>
            <h5 class="name">เลือกช่วงเวลาในการเผยแพร่</h5>
            <RangePublishDatePicker
              :bannerItemIndex="selectedIndex"
              :allItems.sync="allItems"
              :startPublish.sync="item.startPublish"
              :endPublish.sync="item.endPublish" />
            <small class="helper-text">
              <i class="fas fa-info-circle"></i>
              คลิกเลือกวันที่เริ่มต้น จากนั้นคลิกเลือกวันที่สิ้นสุด และกด Apply
            </small>
          </FormGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// System
import FormGroup from '@/components/FormGroup.vue';
// Scoped
import BackgroundImageChooser from '@/pageDesigner/BackgroundImageChooser.vue';
import BannerMixins from '@/pageDesigner/mixins';
import RangePublishDatePicker from '@/pageDesigner/RangePublishDatePicker.vue';
import ElementImageContainer from '@/pageDesigner/ElementImageContainer.vue';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    allItems: {
      type: Array,
      required: true,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
  },
  components: {
    FormGroup,
    RangePublishDatePicker,
    BackgroundImageChooser,
    ElementImageContainer,
  },
  data() {
    return {
      timeMachine: false,
      contentCategories: [],
    };
  },
  mixins: [BannerMixins],
  methods: {
    resetDate() {
      this.item.endPublish = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/themes/components/manage-metadata.scss';

</style>
